function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01RefreshCaptcha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "71px",
    height: "63px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#042b62",
    d: "M 31.5,2.5 C 40.6885,2.01274 48.5218,5.01274 55,11.5C 56.261,17.0798 54.0943,18.9132 48.5,17C 39.1661,9.51415 29.9995,9.68081 21,17.5C 20.8333,17.8333 20.6667,18.1667 20.5,18.5C 22.2744,19.1867 23.9411,20.0201 25.5,21C 22.3219,26.3552 18.6553,31.3552 14.5,36C 13.5,36.6667 12.5,36.6667 11.5,36C 8.78864,32.0776 5.95531,28.2443 3,24.5C 2.01809,23.2411 1.68475,21.9078 2,20.5C 4.47276,19.8803 6.97276,19.2136 9.5,18.5C 14.342,9.64694 21.6754,4.31361 31.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#042b62",
    d: "M 17.5,53.5 C 17.0269,52.0937 16.0269,51.427 14.5,51.5C 13.4019,47.722 14.9019,45.3887 19,44.5C 29.7144,53.9923 40.2144,53.8256 50.5,44C 45.3898,44.5847 43.8898,42.7514 46,38.5C 48.9553,34.7557 51.7886,30.9224 54.5,27C 55.9437,26.2195 57.277,26.3861 58.5,27.5C 62.2214,31.8883 65.5547,36.5549 68.5,41.5C 68.2907,42.086 67.9574,42.586 67.5,43C 65.1667,43.3333 62.8333,43.6667 60.5,44C 52.7966,57.1843 41.4632,62.1843 26.5,59C 23.1019,57.6429 20.1019,55.8096 17.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.698
    },
    fill: "#accfef",
    d: "M 14.5,51.5 C 16.0269,51.427 17.0269,52.0937 17.5,53.5C 15.9731,53.573 14.9731,52.9063 14.5,51.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01RefreshCaptcha);
export default __webpack_public_path__ + "static/media/01_refresh_captcha.2bc161e144ef00211b05d86d9a25030a.svg";
export { ForwardRef as ReactComponent };